import styled from 'styled-components';

import { Form } from '@dreryk/react-components';

export const StyledSoundSourceForm = styled(Form)`
   display: flex;
   flex-direction: column;
   gap: 12px;
   padding: 6px;
`;

StyledSoundSourceForm.displayName = 'StyledSoundSourceForm';
